import React from 'react';

import { BREAKPOINTS, errorColor, unit, unitTRBL, white } from '@zego/theme';
import { TrackingScope } from '@zego/tracking';

import H3 from '@zego/components/atoms/H3';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import IrelandTaxiLeadFormHandler from '@zego/components/leadGeneration/IrelandTaxiLeadFormHandler';

import withPromotionsLayout from '../withPromotionsLayout';
import IrelandTaxiLandingWrapper from './IrelandTaxiLandingWrapper';

import ogImage from '@zego/static/images/social/social-ireland-taxi.jpg';

const IrelandTaxiLandingPage = () => {
  return (
    <IrelandTaxiLandingWrapper>
      <TrackingScope locationName="Ireland Telematics Landing Page">
        <View
          id="ireland-landing-form"
          css={{
            backgroundColor: white,
            padding: unitTRBL(3.5, 2.5, 1.75, 2.5),
            marginLeft: '-22px',
            marginRight: '-22px',
            borderRadius: '0 0 12px 12px',
            [BREAKPOINTS.medium]: {
              borderRadius: '12px 0 12px 12px',
              marginLeft: 0,
              marginRight: 0,
            },
          }}
        >
          <div css={{ position: 'relative' }}>
            <div
              css={{
                position: 'absolute',
                zIndex: 100,
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: errorColor(3),
                borderRadius: '8px 8px 0 0',
                height: 44,
                width: 118,
                right: '-20px',
                top: '-78px',
                padding: '25px 65px 25px 65px',
                [BREAKPOINTS.normal]: {
                  padding: '60px 60px 60px 60px',
                  borderRadius: '75px',
                  right: '-60px',
                  top: '-70px',
                },
              }}
            >
              <RegularText
                css={{
                  color: white,
                  textAlign: 'center',
                  lineHeight: '14px',
                  letterSpacing: '0.4px',
                  fontSize: '17px',
                  fontWeight: 'bold',
                }}
              >
                Prices from €1,734/year<sup>*</sup>
              </RegularText>
            </div>
          </div>
          <H3
            css={{
              fontSize: 18.5,
              [BREAKPOINTS.small]: { fontSize: 18.5 },
            }}
          >
            Fill in your details below:
          </H3>
          <Spacer height={unit(2)} />
          <IrelandTaxiLeadFormHandler buttonLabel="Find out more" />
        </View>
      </TrackingScope>
    </IrelandTaxiLandingWrapper>
  );
};

export default withPromotionsLayout(IrelandTaxiLandingPage, {
  title: 'New taxi insurance from Zego',
  description:
    'New from Zego: taxi insurance for drivers in Ireland. Get great protection at competitive prices with our technology.',
  ogImage: ogImage,
});
